export enum TransferType {
  NoAction,
  MoveToCollection,
  DontMoveToCollection,
}
